export const getAnswerText = (answer) => {
  if (!answer) return ''
  return answer
    .flatMap(a => a.children)
    .filter(Boolean)
    .map(c => c.text)
    .filter(Boolean)
    .join(' ')
}

export const getFaqsForJsonLd = (allFaqs, faqSections) => {
  if (!allFaqs || !faqSections) return []

  const categoryTitles = faqSections
    .flatMap(section => {
      const categories = section.faqCategories || (section.faqCategory ? [section.faqCategory] : [])
      return categories.map(c => c.title)
    })
    .filter(Boolean)

  const filteredFaqs = categoryTitles.length > 0
    ? allFaqs.filter(f => !f.isHidden && f.category && categoryTitles.includes(f.category.title))
    : allFaqs.filter(f => !f.isHidden)

  return filteredFaqs.map(faq => ({
    questionName: faq.question,
    acceptedAnswerText: getAnswerText(faq.answer),
  })).filter(faq => faq.questionName && faq.acceptedAnswerText)
}

export function buildFaqJsonLd(items) {
  if (!items || !items.length) return null
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map(q => ({
      '@type': 'Question',
      name: q.questionName,
      acceptedAnswer: {
        '@type': 'Answer',
        text: q.acceptedAnswerText,
      },
    })),
  }
}
